import React from 'react'
import { useSelector } from 'react-redux'
import { SCREEN } from '../../../../common/selectCurrencyUnit/constant'
import { useFormatCurrency } from '../../../../common/selectCurrencyUnit/useFormatCurrency'
import { Table } from '../../../../common/table'
import { CompanyNameCell } from './CompanyNameCell'
import { NetValueCell } from './NetValueCell'
import { TITLE_TABLE_HEADER } from './constant'
import {
  selectIds,
  selectIsLoadingTableData,
  selectTopPlayersItem,
  selectYear,
} from './store/slice'

export const TopPlayerTableContent = ({ isDynamicReport }) => {
  const { formatCurrency } = useFormatCurrency(SCREEN.INDUSTRY_OVERVIEW)

  const ids = useSelector(selectIds)
  const isLoading = useSelector(selectIsLoadingTableData)
  const year = useSelector(selectYear)

  return (
    <Table
      ids={ids}
      isLoading={isLoading}
      getDataFromRedux={selectTopPlayersItem}
      isStickyFirstCol={!isDynamicReport}
      isNoDataWithHead={false}
      isDisplayScroll={!isDynamicReport}
      isDynamicReport={isDynamicReport}
      isNoStickyHead={isDynamicReport}
      schema={Object.values(TITLE_TABLE_HEADER).map((item) => {
        return {
          title: item.label,
          renderTh: (val) => {
            if (item.key === TITLE_TABLE_HEADER.NET_REVENUE.key) {
              return <NetValueCell val={val} />
            }

            return val
          },
          colId: item.key,
          isI18n: true,
          thStyle: item.thStyle,
          render: (value, { rowId }) => {
            switch (item.key) {
              case TITLE_TABLE_HEADER.COMPANY_NAME.key:
                return isDynamicReport ? (
                  item.format(value)
                ) : (
                  <CompanyNameCell item={item} value={value} rowId={rowId} />
                )
              case TITLE_TABLE_HEADER.NET_REVENUE.key:
                return (
                  <div className="textEnd">
                    {item.format(formatCurrency({ value, year: year.value }))}
                  </div>
                )
              case TITLE_TABLE_HEADER.TOTAL_ASSETS.key:
                return (
                  <div className="textEnd">
                    {item.format(
                      formatCurrency({
                        value,
                        year: year.value,
                        exchangeRateType: 'lastDayRate',
                      }),
                    )}
                  </div>
                )

              default:
                return item.format(value)
            }
          },
        }
      })}
    />
  )
}
